import React, { useEffect, useState } from 'react';
import { useDispatch } from "react-redux";
import { addCart } from "../redux/action";
import { Link, useParams, useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import axios from 'axios';
import { CartUpdate } from "../services/CartUpdate";
import { FavoriteBorderOutlined, Favorite, ShoppingCart } from '@mui/icons-material';
import { Url } from '../services/Constants';
import { useLocation } from 'react-router-dom';
import { GetUserRole } from '../services/UserRole';
import { setHeader } from '../services/Headers'
import { addFavorite, removeFavorite } from '../redux/action';

export default function ProductTiles({ products, totalPages, currentPage, onPageChange,getProduct }) {
  const [usertype, setUserType] = useState(false);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const categoryId = query.get('category_id');
  const navigate = useNavigate();
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const userRole = GetUserRole();
  const dispatch = useDispatch();
  const [quantity, setQuantity] = useState(1)
  const { id } = useParams();

  const addProduct = async (product) => {
    try {
        dispatch(addCart(product));
        CartUpdate();
        toast.success("Product added to cart.")
    } catch (error) {
        console.error('Error adding product to cart:', error);
        toast.error("Error adding product to cart!")
    }
  };


  const handleProductClick = async (productId) => {
    // const productDetailsPath = userRole === "seller"
    //   ? `${Url}/seller/products/${productId}`
    //   : `${Url}/buyer/products/${productId}`;

    try {
      // const response = await axios.get(productDetailsPath);

      navigate(`/product-detail/${productId}`);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  const fetchFavoriteProducts = async () => {
    if (userRole === "buyer") {
      try {
        const response = await axios.get(`${Url}/buyer/products/favourite_products`, setHeader());
        const favoriteIds = response.data.response_data.products.map(product => product.id);
        setFavoriteProducts(favoriteIds);
      } catch (error) {
        console.error("Error fetching favorite products:", error.response ? error.response.data : error.message);
      }
    }
  };

  useEffect(() => {
    fetchFavoriteProducts();
  }, []);

  const addtoCart = async(product)=>{
    if (product.product_variants[0].left_qty === 0) {
      toast.error("Product is out of stock!")
    }else{
      try {
        const result = await axios.get(`${Url}/buyer/products/check_available_quantity?product_variant_id=${product.product_variants[0].id}&quantity=${quantity}`)
        if(result.data.response_code===200){
          const data = {
            cart_id:"",
            quantity:quantity,
            seller_name:product.seller_name,
            product_name:product.name,
            product_image:product.product_images[0].image,
            category:product.category_name,
            product_variant_id:product.product_variants[0].id,
            stock_qty:product.product_variants[0].stock_qty,
            left_qty:product.product_variants[0].left_qty,
            price:product.product_variants[0].price,
            discounted_price:product.product_variants[0].discounted_price,
            gst:product.product_variants[0].gst,
            product_code:product.category_id,
            isOutOfStock:""
          }
          addProduct(data)
        }else{
          toast.error("Required quantity is not available!")
        }
      } catch (error) {
        console.log(error)
      }
    }
  }

  const deleteHandle = async(e)=>{
    try {
      const result = await axios.get(`${Url}/seller/get_profile`,setHeader())
      if(result.data.response_code ===200){
        const confirmed = window.confirm("Do yo want to delete product?")
        if(confirmed)
        {
          try {
            const deleteProduct = await axios.delete(`${Url}/seller/products/${e.target.id}`,setHeader())
            if(deleteProduct.data.response_code===200){
              toast.success("Product deleted successfully.")
              getProduct();
            }
            else{
              toast.error("Something went wrong!")
            }
          } catch (error) {
            console.log(error)
          }
        }
      }

    } catch (error) {
      console.log(error)
    }
  }


  const handleFavoritesClick = async (productId) => {
    try {
      if (userRole === "buyer") {
        const isFavorite = favoriteProducts.includes(productId);
        const response = await axios.post(
          `${Url}/buyer/products/${productId}/favourite_unfavourite?is_favourite=${!isFavorite}`,
          {},
          setHeader()
        );
  
        if (response.status === 200) {
          if (isFavorite) {
            dispatch(removeFavorite(productId));
            toast.success("Product removed from favorites!");
            setFavoriteProducts(favoriteProducts.filter(id => id !== productId));
          } else {
            dispatch(addFavorite(productId));
            toast.success("Product added to favorites!");
            setFavoriteProducts([...favoriteProducts, productId]);
          }
        }
      }
    } catch (error) {
      console.error("Error updating favorites:", error);
      toast.error("Failed to update favorites.");
    }
  };

  return (
    <div className="container mx-auto pl-3">
      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {products.map((product) => (
          <div
            key={product.id}
            className="feed-container cursor-pointer rounded-xl shadow-lg border-2 mt-4 object-cover"
          >
            <div className="feed-top group relative flex">
              {userRole === "buyer" && (
                <div onClick={() => handleFavoritesClick(product.id)}>
                  {favoriteProducts.includes(product.id) ? (
                    <Favorite className="fav-icon absolute right-2 top-2 p-[1%] z-20 rounded-full bg-white text-red-500" />
                  ) : (
                    <FavoriteBorderOutlined className="invisible fav-icon absolute right-2 top-2 p-[1%] z-20 rounded-full bg-white hover:bg-sky-700 hover:text-white group-hover:visible" />
                  )}
                </div>
              )}
              {userRole === "seller" && (
                <div id={product.id} className="absolute top-2 right-2 cursor-pointer z-20 border border-black rounded-full p-2 bg-white hover:bg-gray-200 text-sm flex items-center justify-center w-8 h-8" onClick={deleteHandle}>
                  &times;
                </div>
              )}
              <img
                src={product.product_images[0].image}
                alt={product.name}
                className="group-hover:opacity-50 w-full h-52 rounded-t-xl"
                onClick={() => handleProductClick(product.id)}
              />
            </div>
            
<div className="bottom p-2 flex items-center justify-between">
  <div className="flex-1 min-w-0"> {/* min-w-0 is key for truncation in flex layouts */}
    <span className="block text-xl w-full truncate text-amber-950 font-bold">
      {product.name}
    </span>
    <span className="truncate block max-h-10 text-amber-950 text-sm md:text-base">
      {product.category_name}
    </span>

    {/* Price and Add to Cart Button Container */}
    <div className="flex items-center justify-between mt-1">
      <div className="flex flex-row items-center space-x-2">
        <span className="text-sm md:text-lg font-bold text-amber-950">
          Rs. {product.product_variants[0].discounted_price}
        </span>
        <span className="text-sm md:text-lg text-gray-500 line-through">
          {product.product_variants[0].price}
        </span>
      </div>

      {/* Add to Cart Button */}
      {userRole !== "seller" && (
        <button
          onClick={() => addtoCart(product)}
          className="flex-shrink-0 bg-amber-950 text-white p-2 rounded-full hover:bg-amber-800 shadow-md text-sm md:text-base"
        >
          <ShoppingCart />
        </button>
      )}
    </div>
  </div>
</div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-4">
        <span className="text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </span>
        <div className="flex gap-2">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
          >
            &laquo;
          </button>
          {
            Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                onClick={() => onPageChange(index + 1)}
                className={`px-3 py-1 rounded ${currentPage === index + 1 ? 'bg-amber-950 text-white' : 'bg-gray-200 hover:bg-gray-300'
                  }`}
              >
                {index + 1}
              </button>
            ))}
          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded disabled:opacity-50"
          >
            &raquo;
          </button>
        </div>
      </div>
    </div>
  );
}
